<template>
  <!--
        作者：kmdshop
        时间：2019-10-25
        描述：权限-管理员列表-添加管理员
    -->
  <el-dialog title="添加客户" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">

    <!--form表单-->

                


    <el-form size="small" ref="form" :model="form" :rules="formRules" :label-width="formLabelWidth">
      
      <!-- <el-form-item  >
                <Supply :form="form" ></Supply>
           
            </el-form-item> -->
      
            <el-form-item label="绑定上级"  :label-width="formLabelWidth">
                <el-row>
                <el-button @click="addClick" icon="el-icon-plus">选择上级</el-button>
                <div v-if="form.referee_id!=''" class="img">
                    <img :src="form.agent.avatarUrl" width="100" height="100" />
                </div>
                <div>
                    <el-link :underline="false" disabled>选择后不可更改</el-link>
                </div>
                </el-row>
            </el-form-item>      

            
      <el-form-item label="客户姓名" prop="nickName" :rules="[{required: true,message: '姓名不能为空'}]">
        <el-input v-model="form.nickName" placeholder="请输入姓名"></el-input>
      </el-form-item>

      <el-form-item label="手机号码" prop="mobile" :rules="[{required: true,message: '手机号不能为空'}]">
        <el-input v-model="form.mobile" maxlength=11 placeholder="请输入手机号码"></el-input>
      </el-form-item>

      <el-form-item label="标签" prop="label" >
        <el-input v-model="form.label" placeholder="请输入标签"></el-input>
      </el-form-item>

            
      <el-form-item label="角色"  :label-width="formLabelWidth">
   
   <el-select v-model="form.role" placeholder="请选择">
       <el-option v-for="(item, index) in rolearr" :key="index" :label="item.label" :value="item.value"></el-option>
   </el-select>
</el-form-item>


      <el-form-item label="等级" :label-width="formLabelWidth" >
        <el-select v-model="form.grade_id" placeholder="-默认等级-">
          <el-option v-for="(item,index) in gradeList" :key="index" :label="item.name" :value="item.grade_id"></el-option>
        </el-select>
      </el-form-item>



      <!-- <el-form-item label="会员等级" prop="role_id">
        <el-select v-model="form.role_id" :multiple="true">
          <el-option v-for="item in roleList" :value="item.role_id" :key="item.role_id" :label="item.role_name_h1"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="会员到期时间" :label-width="formLabelWidth">
        <el-date-picker v-model="form.expire_date_text" type="datetime" placeholder="选择日期时间" align="right" :picker-options="timePickerOpt"></el-date-picker>
        <p class="gray">会员到期时间到了,会员等级自动降级到 {{ (gradeList && gradeList.length > 0) ? '[' + gradeList[0].name + ']' : '默认等级' }}</p>
      </el-form-item>




    </el-form>

    <el-form size="small" ref="store" :model="store"  :label-width="formLabelWidth">
      <el-form-item label="是否添加门店" prop="is_open_store">
        <el-switch v-model="form.is_open_store" 
        :active-value="1" :inactive-value="0"
        ></el-switch>
      </el-form-item>  


      <div class="common-form" v-if="form.is_open_store">添加门店</div>
      <div v-if="form.is_open_store">
        <Supplys :form="store"  ></Supplys>


      <el-form-item label="门店名称" prop="store_name" :rules="[{required: true,message: '请输入门店名称'}]">
        <el-input v-model="store.store_name" placeholder="请输入门店名称" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="门店logo">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload">选择图片</el-button>
          <div v-if="store.logo!=''" class="img">
            <img :src="store.logo" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="联系人" prop="linkman" :rules="[{required: true,message: '请输入门店联系人'}]">
        <el-input v-model="store.linkman" placeholder="请输入门店联系人" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="phone" :rules="[{required: true,message: '请输入门店联系电话'}]">
        <el-input v-model="store.phone" placeholder="请输入门店联系电话" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="客服联系电话" prop="cs_phone" >
        <el-input v-model="store.cs_phone" placeholder="请输入客服联系电话" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="营业开始时间" prop="shop_hours" >
        <el-input v-model="store.shop_hours_start" placeholder="请输入营业开始时间,例如:8:30" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="营业结束时间" prop="shop_hours" >
        <el-input v-model="store.shop_hours_end" placeholder="请输入营业结束时间,例如:17:30" class="max-w460"></el-input>
      </el-form-item>



      <el-form-item label="门店区域">
      <el-select v-model="store.province_id" placeholder="省" @change="initCity">
        <el-option :label="item.name" :value="item.id" v-for="(item,index) in areaList" :key='index'></el-option>
      </el-select>
      <el-select v-if="store.province_id!=''" v-model="store.city_id" placeholder="市" @change="initRegion">
        <el-option :label="item1.name" :value="item1.id" v-for="(item1,index1) in areaList[store.province_id]['city']"
          :key='index1'></el-option>
      </el-select>
      <el-select v-if="store.city_id!=''" v-model="store.region_id" placeholder="区">
        <el-option :label="item2.name" :value="item2.id" v-for="(item2,index2) in areaList[store.province_id]['city'][store.city_id]['region']"
          :key='index2'></el-option>
      </el-select>


      </el-form-item>
      <el-form-item label="详细地址" prop="address" :rules="[{required: true,message: '请选择详细地址'}]">
      <el-input v-model="store.address" placeholder="请输入详细地址" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="门店坐标">
      <el-row class="mb16">
        <el-col :span="24">
          <el-input v-model="store.coordinate" class="max-w460"></el-input>
        </el-col>
      </el-row>
      <el-row class="mb16">
        <el-col :span="24">
          <Getpoint :form="store" @getMapdata="getMapdataFunc" @chose="choseFunc"></Getpoint>
        </el-col>
      </el-row>

      </el-form-item>




      <el-form-item label="门店排序">
      <el-input type="number" v-model="store.sort" placeholder="请输入门店排序" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="门店状态">
      <el-radio-group v-model="store.status">
        <el-radio :label="1">启用</el-radio>
        <el-radio :label="0">禁用</el-radio>
      </el-radio-group>
      </el-form-item>
            </div>
      
      </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
    </div>
    <GetUser :is_open="open_add" @close="closeDialogFunc" :multi="false"></GetUser>
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>

  </el-dialog>
</template>

<script>
  import Getpoint from '@/components/map/Getpoint.vue';
import UserApi from '@/api/user.js';
import Supply from '@/components/supply/supply_commonu.vue';
import GetUser from '@/components/user/GetSales.vue';
import Supplys from './Supplys';
import StoreApi from '@/api/store.js';
import Upload from '@/components/file/Upload';
import select_region from '@/utils/select.district.js';
export default {
      components: {
        /*编辑组件*/
          GetUser,
          Supply,
          Supplys,
          Upload,
          Getpoint
        },
  data() {
    return {
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      loading: false,
      /*是否显示*/
      dialogVisible: false,
      /*form表单对象*/
      form: {
        nickName: '',
        access_id: [],
        // 会员到期时间设置
        expire_date_text: '',
        supply:{},
        label:"",
        referee_id:0,
        is_open_store:1,
        role:"supply"
    
      },
 
      /*form验证*/
      formRules: {
        nickName: [
          {
            required: true,
            message: '名字不能不为空',
            trigger: 'blur'
          }
        ],
        grade_id: [
          {
            required: true,
            message: ' ',
            trigger: 'blur'
          }
        ],
        mobile: [
          {
            required: true,
            message: '手机号码不能为空',
            trigger: 'blur'
          }
        ],
      },
      // 会员到期时间选择器左侧快捷选项
      timePickerOpt: {
        shortcuts: [{
          text: '一年',
          onClick(picker) {
            const date = new Date()
            date.setFullYear(date.getFullYear() + 1)
            picker.$emit('pick', date)
          }
        }, {
          text: '两年',
          onClick(picker) {
            const date = new Date()
            date.setFullYear(date.getFullYear() + 2)
            picker.$emit('pick', date)
          }
        }, {
          text: '三年',
          onClick(picker) {
            const date = new Date()
            date.setFullYear(date.getFullYear() + 3)
            picker.$emit('pick', date)
          }
        }]
      },
      rolearr:[],
      open_add: false,
      store:{
          store_name: '',
          logo_image_id:0,
          logo:"",
          linkman: '',
          phone: '',
          shop_hours: '',
          shop_hours_start:"",
          shop_hours_end:'',
          province_id: '',
          city_id: '',
          region_id: '',
          town_id: '',
          village_id: '',
          address: '',
          coordinate: '',
          summary: '',
          sort: 1,
          is_check: 1,
          status: 1,
          store_qrcode: '',
          store_wxapp_url: '',
          store_wxappid: '',
          is_search_map:false,
          audit_status:1,//1   通过  2  驳回
          reject_reason:"",//不通过理由
          user_id: 0,
          cs_phone:"",
          service:[],
          supply_id:0,
          user_supply:{},
          supply:{}
        },
       /*省市区*/
       areaList: select_region,
       isupload:false,
    }
  },
  props: ['open', 'roleList','gradeList'],
  watch: {
    open: function(n, o) {
      if (n != o) {
        this.dialogVisible = this.open;
      }
    }
  },
  created() {
    this.getRole();
  },
  methods: {
              /*打开弹出层*/
              addClick() {
                this.open_add = true;
            },

            /*关闭获取用户弹窗*/
            closeDialogFunc(e) {
                if (e.type != 'error') {
                this.form.agent = e.params;
                this.form.referee_id = e.params.user_id;
                }
                this.open_add = false;
            },
    
    getRole(){
                let self = this

                let Params = {}

                UserApi.getRole(Params, true)
                    .then(data => {
                    self.rolearr = data.data
                    })
                    .catch(error => {

                    });
            },
    /*添加*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = self.form;
      self.$refs.form.validate((valid) => {
        if(valid){
  
          if( self.form.is_open_store == 1){
            self.$refs.store.validate((valids) => {
              if(valids){
                UserApi.adduser(params, true)
          .then(data => {
            self.loading = false;
  
            if( self.form.is_open_store == 1){
              let store = self.store;
            store.user_id = data.data;
           
              StoreApi.addShop(store, true)
                  .then(data => {
                    self.loading = false;
                    if (data.code == 1) {
                      self.$message({
                        message: '恭喜你，添加成功',
                        type: 'success'
                      });
                      self.form.nickName=''
                      self.form.mobile=''
                      self.form.grade_id=''
                      self.dialogFormVisible(true);
                    } else {
                      self.loading = false;
                    }
                  })
                  .catch(error => {
                    self.loading = false;
                  });
            
            }else{
              self.form.nickName=''
                      self.form.mobile=''
                      self.form.grade_id=''
                      self.dialogFormVisible(true);
            }
        
    

   
       
          })
          .catch(error => {
            self.loading = false;
          });
              }
            })
          }else{
            UserApi.adduser(params, true)
          .then(data => {
            self.loading = false;
            self.form.nickName=''
                      self.form.mobile=''
                      self.form.grade_id=''
                      self.dialogFormVisible(true);
          })
          }
       
          
          
   
        }if(!valid){
          self.loading = false;
        }

      });


    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('close', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('close', {
          type: 'error',
          openDialog: false
        });
      }
    },
     /*初始化城市id*/
     initCity() {
        this.store.city_id = ''
      },

      /*初始化区id*/
      initRegion() {
        this.store.region_id = ''
      },

      /*获取经纬度*/
      getMapdataFunc(e) {
        this.store.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
      },
            /*上传*/
            openUpload(e) {
        this.file_type = e;
        this.isupload = true;
      },

      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          if(this.file_type=='qrcode'){
            this.store.store_qrcode = e[0].file_path;
          }else{
            this.store.logo = e[0].file_path;
          }
          
        }
        this.isupload = false;
      },

      /*选择的地址*/
      choseFunc(e){
        this.store.coordinate=e.location.lat+','+e.location.lng;
        this.store.address=e.address;

      },
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/user/user/dialog/Add.vue